import { Grid } from "antd";
import React, { useState } from "react";
import { DesktopMenu } from "./components/DesktopMenu/DesktopMenu";
import { MobileMenu } from "./components/MobileMenu/MobileMenu";

const MegaMenu = (props) => {
  const {
    megacta,
    tnavfirst,
    tnavsecond,
    tnavthird,
    bnavfirst,
    bnavsecond,
    bnavthird,
    rightmenu,
    datalinks,
    mcontact,
    homeurl,
    search,
  } = props;
  const [toggleMenu, setToggleMenu] = useState(false);

  // Breakpoints
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { xl } = screens;

  // Toggle menu
  const openMegaMenu = () => {
    setToggleMenu(!toggleMenu);
  };

  // Change menu title
  const menuTitle = () => {
    if (toggleMenu) {
      return "Sulje";
    }
    return "Valikko";
  };

  const homeUrl = `${homeurl}/?s`;

  return (
    <>
      <div className="megamenu__top">
        {xl && megacta && (
          <ul className="megamenu__top menu">
            {megacta.map((item) => (
              <li>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        )}

        <div className="buttons">
          <ul className="d-flex align-items-center">
            <li>
              <a
                className="btn muotolevy-button__md search js-muotolevy-search-header"
                href={homeUrl}
                onClick={() => setToggleMenu(false)}
              >
                <img src={search} />
              </a>
            </li>
          </ul>
        </div>

        <a
          role="button"
          className={
            toggleMenu
              ? "btn muotolevy-button__md megamenu-button red-btn"
              : "btn muotolevy-button__md megamenu-button"
          }
          onClick={openMegaMenu}
        >
          {" "}
          {lg ? menuTitle() : ""}
          <button
            className={
              toggleMenu
                ? "hamburger hamburger--squeeze nav-toggle is-active"
                : "hamburger hamburger--squeeze nav-toggle"
            }
            type="button"
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
        </a>
      </div>

      {lg
        ? toggleMenu && (
            <DesktopMenu
              tnavfirst={tnavfirst}
              tnavsecond={tnavsecond}
              tnavthird={tnavthird}
              bnavfirst={bnavfirst}
              bnavsecond={bnavsecond}
              bnavthird={bnavthird}
              rightmenu={rightmenu}
              mcontact={mcontact}
              datalinks={datalinks}
            />
          )
        : toggleMenu && (
            <MobileMenu
              megacta={megacta}
              tnavfirst={tnavfirst}
              tnavsecond={tnavsecond}
              tnavthird={tnavthird}
              bnavfirst={bnavfirst}
              bnavsecond={bnavsecond}
              bnavthird={bnavthird}
              rightmenu={rightmenu}
              mcontact={mcontact}
              datalinks={datalinks}
            />
          )}
    </>
  );
};

export default MegaMenu;
